import request from '@/utils/request'

export function getUserAddressDefault(userId) {
  return request({
    url: '/address/getUserAddressDefault',
    method: 'get',
    params: {userId: userId}
  })
}



// WEBPACK FOOTER //
// ./src/api/address.js